import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useBlogContext } from '../../../context/BlogContext';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './BlogPost.css';

export const BlogPost: React.FC = () => {
    const { title } = useParams<{ title: string }>();
    const { blogs } = useBlogContext();
    const navigate = useNavigate();

    const decodedTitle = decodeURIComponent(title || '').replace(/-/g, ' ');
    const blog = blogs.find(b => b.title.toLowerCase() === decodedTitle.toLowerCase());

    if (!blog) {
        return (
            <div className="blog-page">
                <div className="blog-post">
                    <button className="blog-back" onClick={() => navigate('/blog')}>← back</button>
                    <p>Post not found.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="blog-page">
            <article className="blog-post">
                <button className="blog-back" onClick={() => navigate('/blog')}>← back</button>
                <header>
                    <h1>{blog.title}</h1>
                    <p className="author">
                        {blog.author || 'Unknown'} &mdash;{' '}
                        {new Date(blog.published_at).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                        })}
                    </p>
                </header>
                <div className="content">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{blog.content}</ReactMarkdown>
                </div>
            </article>
        </div>
    );
};
